"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HEADER_BUTTON_STATES = void 0;
const HEADER_BUTTON_STATES = exports.HEADER_BUTTON_STATES = {
  off: 'off',
  disabled: 'disabled'
};